<template>
<span style="width:100%" @click="dateClick()" ref="dateFiexd" :class="[clearable ? '' : 'hidden-clear-icon']">
    <label-date-picker 
            ref="labelPicker"
            clear-icon 
            :format="format"  
            :value-format="valueFormat"  
            @focus="dateFocus" 
            @blur="dateBlur"
            :clearable="clearable"
            :type="type"
            :range-separator="rangeSeparator"
            v-bind="$attrs"
            v-on="$listeners"
            :label="label"
           > 
     </label-date-picker>
    <!-- <h3>
    </h3> -->
</span>
          


</template>

<script>
import LabelDatePicker from "@/components/label-input-v2/date";
import moment from "moment-timezone";
// let pickmarker = 0
export default {
    name: 'datePicker',
    props: {
        clearable: {
            default: true
        },
        inputWidth: {
            required: false,
            default: ''
        },
        type: {
            type: String,
            required: false,
            default: 'date'
        },
        format: {
            type: String,
            required: false,
            default: 'M/d/yyyy'
        },
        valueFormat: {
            type: String,
            required: false,
            default: 'timestamp'
        },
        form: {
            type: Object,
            require: true,
            default: function() {
                return {}
            }
        },
        label: {
            type: String,
            require: false,
            default: ''
        },
        // hasShortcuts: {
        //     type: Boolean,
        //     default: false
        // },
    },
    data() {
        return {
            isColor: false,
            rangeSeparator:'',
            pickmarker: '',
            shortcutsList: [
                {
                    text: 'Last 7 Days',
                    time: [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
                },
                {
                    text: 'Last 15 Days',
                    time: [moment().subtract(15, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
                },
                {
                    text: 'Last 30 Days',
                    time: [moment().subtract(30, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
                },
                {
                    text: 'Last 3 Months',
                    time: [moment().subtract(3, 'months').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
                },
                {
                    text: 'Last 12 Months',
                    time: [moment().subtract(1, 'year').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
                },
                {
                    text: 'Any Date',
                    time: []
                },
                {
                    text: 'Customized',
                    time: [],
                    isDisabled: true
                },
            ]
        }
    },
    // created() {
    //     pickmarker++
    //     this.pickmarker = 'popperclassMark' + pickmarker
    // },
    
    watch: {
        // 监听$attrs
        $attrs: {
            handler(value) {
                this.rangeSeparator = ''
                if(value.value && value.value.length > 0) {
                    this.rangeSeparator = '-'
                }
                
                // if (this.hasShortcuts) {
                //     let pickerOptions = value.pickerOptions || value['picker-options']
                //     console.log(pickerOptions, 'value')
                //     if (pickerOptions) {
                //         pickerOptions.shortcuts = this.shortcutsList.map(item => {
                //             return {
                //                 text: item.text,
                //                 onClick(picker) {
                //                     if (item.time && item.time.length > 0) {
                //                         console.log([parseFloat(moment(item.time[0]).format('x')), parseFloat(moment(item.time[1]).format('x'))], 'da')
                //                         picker.$emit('pick', [moment(item.time[0]).format('x'), moment(item.time[1]).format('x')])
                //                     } else if (!item.isDisabled) {
                //                         picker.$emit('pick', [])
                //                     }
                //                 }
                //             }
                //         })
                //     }
                // }
            },
            immediate: true,
            deep: true,
        },
        form: {
            handler(news) {
                // console.log(news.date,'71')
                if(news) {
                    this.$forceUpdate()
                    this.isColor = false;
                }
            },
        },
        deep: true
    },
    methods: {
        dateFocus() {
            this.isColor = true
            try {
                // if (this.hasShortcuts) {
                //     const node = document.getElementsByClassName(this.pickmarker)
                //     const list = node.querySelectorAll('.el-picker-panel__shortcut')
                //     if (this.$attrs.value && this.$attrs.value.length > 0) {
                //         let start = moment(this.$attrs.value[0]).format('YYYY-MM-DD')
                //         let start = moment(this.$attrs.value[0]).format('YYYY-MM-DD')
                //     }
                //     console.log(this.$attrs, node, 'node')
                // }
                
                let inDom = document.querySelectorAll('.in-range');
                
                // document.querySelector('.el-popper').style = 'margin-top: 6px'
                document.querySelectorAll('.popper__arrow').forEach(item => item.style = `display: none`);
                document.querySelectorAll('th').forEach(item => item.style = `color:#b2b6c0;`);
                if(this.type !== 'date') {
                    console.log(this.valueFormat,'92');
                    inDom.forEach((item) => {   
                        item.children[0].style = 'background:0;';
                    })
                }
                document.querySelectorAll('.available').forEach(item => item.children[0].children[0].style = `font-weight: bold; border-radius: 2px;`)
                document.querySelectorAll('.el-range-editor').forEach(item => item.style = `padding: 0 10px;`)
                this.$nextTick(() => {
                    document.querySelector('.el-date-table__row').querySelectorAll('td').forEach(item => item.style = 'padding: 12px 0 4px 0;')
                })
               
            } catch (error) {
                //  eslint-disable-next-line
            }
        },
        dateClick() {
            let el = this.$refs['dateFiexd'].children[0].children[1].children[1];
            el.focus()
        },
        dateBlur(value) {
            //   console.log(value,'113')
              this.rangeSeparator = '';
              if (Array.isArray(value)) {
                  if (value.length) {
                    this.rangeSeparator = '-';
                  }
              } else if(value) {
                  this.rangeSeparator = '-';
              }
            this.$forceUpdate()
            this.isColor = false
            // console.log(this.form,'115')
            // if(!this.form) {
            //      document.querySelectorAll('.el-icon-date').forEach(item => item.style = `display: none`)
            // }
             
        }
    },
    components: { LabelDatePicker },
}
</script>

<style lang="scss" scoped>
span {
    display: inline-block;
    position: relative;
}
h3 {
    position: absolute;
    top: 9px;
    right: 12px;
}

/deep/ .el-range__close-icon {
    line-height: 38px !important;
}
/deep/ .el-input__icon {
    width: 16px;
    margin-right: 8px;
    &::before {
        position: relative;
        content: url("../images/icon-16-date-2.svg");
    }
    &:hover {
        // margin-bottom: 10px;
        position: relative;
        top: 2px;
        content: url("../../assets/img/common-icon/icon-16-close.svg");
    }
}
.hidden-clear-icon {
    /deep/ {
        .el-input__icon:hover {
            top: 0px;
            content: '';
        }
    }
}
/deep/ .el-input.is-disabled .el-input__icon:hover {
    content: '';
}
/deep/ .el-date-editor .el-range__close-icon {
    width: 16px;
    // position: relative !important;
    // right: 10px !important;
    &::before {
        // position: relative;
        // right: 5px;
    }
}
// /deep/ .el-input__suffix .el-input__suffix-inner .el-input__icon{ 
//         display: none;
// }
/deep/ .el-date-editor.is-disabled {
     .el-input__icon {
         &::before {
            display: block;
            height: 16px;
            width: 16px;
            content: url("../images/icon-16-date-2.svg");
            transform: translateY(2px) translateX(-4px);
        }
       
     } 
    .el-input__icon::after {
        display: none;
    }
} 
/deep/.el-date-editor {
  &.is-active {
    box-shadow: 0 0 0 2px #c6d1f2 !important;
  }
}
/deep/ .el-range-input {
    width: 43% !important;
}
// /deep/ .popper__arrow {
//     display: none;
// }

/deep/ .el-range-editor{
    & > i.el-range__icon:first-child{
        display: none;
    }
}
</style>
